import { DateTime } from "@ankaadia/ankaadia-shared";

const mouseClickDebounceTime = 1000; // in ms

export class ClickListenerProvider {
  private lastClickTime = 0;

  constructor(private readonly name: string) {}

  readonly listener = (event: MouseEvent): void => {
    const now = DateTime.now().getTime();
    if (now - this.lastClickTime >= mouseClickDebounceTime) {
      this.lastClickTime = now;

      // eslint-disable-next-line no-console
      console.log(`${this.name} click event was allowed.`);
    } else {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      // eslint-disable-next-line no-console
      console.log(`${this.name} click event was prevented due to debounce time.`);
    }
  };
}
